/** imported components

  * TrainingCardControler ===> component controller.
  * useState, useEffect ===> React hooks (useState is a way to get/set value)

**/
import React, { useState, useEffect } from "react";
import { TrainingCardControler } from "../training-card/training-card-ctrl";

//TrainingsView component start
export const TrainingsView = ({ trainingData, props }) => {
	const [trainingPop,setTrainingPop] = useState(false);
	const [trainingPopslug,setTrainingPopSlug] = useState(false);
	//defining variables and conditions here
	if (!trainingData.length) {
		return null;
	}
	let avaltrainging = 0;
	trainingData.map((items, index) => {
		if (items.has_paid == 0) {
			avaltrainging = avaltrainging + 1;
		}
	});
	// Popup
	const handleTrainingPopup =(e,slug)=>{
        e.preventDefault();
        setTrainingPop(true);
        setTrainingPopSlug(slug);
      }
      const handleCloseButton =()=>{
        setTrainingPop(false);
      }
      const handleYesButton =(slug)=>{
        window.location = `/skill-assessment/${slug}`;
        setTrainingPop(false);
      }
      const handleNoButton =(slug)=>{
        setTrainingPop(false);
        window.location = `/training-courses/${slug}`;
      }

	return (
		/* this section has
			heading
			main-training-sec
			available-training-sec
		*/ 
		<div className="main-course-page">
			<h1 className="h1">All IR4.0 training courses</h1>
			{/* this section has 
				heading
				train-card-row-container
			*/}
			<section className="main-training-sec">
				{/* <h2 className="h2">IR4.0 trainings</h2> */}
				{/* this section has row */}
				 <div className="train-card-row-continer">
					<div className="training-card-row">
						{trainingData.map((items, index) => {
							if (items.has_paid == 1) {
								return (
									<div className="training-card-col" key={index}>
										<div className={`training-card-popup-wrapper ${items.is_first_training?'active':''}`}>
											<TrainingCardControler
												data={{
													cardTitle: items.course_name,
													cardId: items.id,
													cardSlug: items.course_slug,
													cardImg: require(`../../assets/img/training-card/${items.course_icon}`).default,
													isImd: items.is_imd,
													cardDuration: items.total_sec_dur,
													cardStatus: items.cardStatus,
													isAvailable: false,
													isFirstTraining:items.is_first_training,
												}}
											/>
											<button className="training-transparent-btn" onClick={(e)=>{(items.skill_done == 0 && items.cardStatus == "" )? handleTrainingPopup(e,items.course_slug):''}}></button>
										</div>
									</div>
								);
							}
						})}
					</div>
				</div> 
			</section>
			{/* main-training-sec end   */}
			<section className="available-training-sec">
				{/* {avaltrainging > 0 ? <h2 className="h2">Available IR4.0 trainings</h2> : <></>} */}
				<div className="train-card-row-continer">
					<div className="training-card-row">
						{trainingData.map((items, index) => {
							if (items.has_paid == 0 ) {
							return (
									<div className="training-card-col" key={index}>
										<TrainingCardControler
											data={{
												cardTitle: items.course_name,
												cardId: items.id,
												cardSlug: items.course_slug,
												cardImg: require(`../../assets/img/training-card/${items.course_icon}`).default,
												isImd: items.is_imd,
												cardDuration: items.total_sec_dur,
												cardStatus: items.cardStatus,
												isAvailable: true,
												availableText: items.course_snippet,
												availableTechnology: items.course_technology,
												isFirstTraining:items.is_first_training,
											}}
										/>
									</div>
							);
							 }
						})}
					</div>
				</div>
			</section>
			{/*available-training-sec end   */}
			{/* Assessment Popup */}
			{trainingPop && 
				<div className="training-course-pop-wrapper">
					<div className="training-course-pop">
						<div className="training-course-pop-head">
							<span>Assess your Course Assessment</span>
							<button className="taining-close-btn" onClick={()=>handleCloseButton()}>
								<i dangerouslySetInnerHTML={{__html:closeSvg}}></i>
							</button>
						</div>
						<div className="training-course-pop-body">
							<h2 className="training-head">
								Do you still want to assess your skills in this IR4.0 dimension?
							</h2>
							<span className="training-sub-text">Skills Assessment will not be available once the course is started.</span>
						</div>
						<div className="training-course-pop-footer">
							<button className="training-btn no-btn" onClick={()=>handleNoButton(trainingPopslug)}>No</button>
							<button className="training-btn yes-btn" onClick={()=>handleYesButton(trainingPopslug)}>Yes</button>
						</div>
					</div>
				</div>
			}
		</div>
	);
};

const closeSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M5.63606 7.05025C5.24553 6.65973 5.24553 6.02656 5.63606 5.63604C6.02658 5.24552 6.65974 5.24551 7.05027 5.63604L18.364 16.9497C18.7545 17.3403 18.7545 17.9734 18.364 18.364C17.9735 18.7545 17.3403 18.7545 16.9498 18.364L5.63606 7.05025Z" fill="#4D4D4F"/>
<path d="M5.63606 18.364C5.24553 17.9734 5.24553 17.3403 5.63606 16.9497L16.9498 5.63604C17.3403 5.24552 17.9735 5.24552 18.364 5.63604C18.7545 6.02656 18.7545 6.65973 18.364 7.05025L7.05027 18.364C6.65975 18.7545 6.02658 18.7545 5.63606 18.364Z" fill="#4D4D4F"/>
</svg>`
